// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4aaf2534a2c997585b99f5684163dcc6b9a217d8/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};